// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__peZKa","input":"Checkbox_input__3-o-L","label":"Checkbox_label__38oPG"};